import { isEmpty } from "lodash";
import { usePunditUserContext } from "@circle-react/contexts";

export const usePlanHasCustomizeCommunity = () => {
  const { currentCommunity } = usePunditUserContext();
  return Boolean(currentCommunity?.customize_community_feature_flag_enabled);
};

export const useIsDarkModeBeta = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isDarkModeEnabled = !!currentCommunitySettings?.dark_mode_enabled;

  if (isEmpty(currentCommunitySettings)) {
    return true;
  }

  return isDarkModeEnabled;
};

export const useIsCustomizeCommunityAvailable = () => {
  const hasPlanCustomize = usePlanHasCustomizeCommunity();
  const isDarkmodeBeta = useIsDarkModeBeta();
  const { currentCommunitySettings } = usePunditUserContext();
  const isCustomizeBeta = Boolean(
    currentCommunitySettings?.customize_community_enabled,
  );

  return isDarkmodeBeta && isCustomizeBeta && hasPlanCustomize;
};
